import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SERVER_API_URL } from '@app/app.constants';

@Injectable({ providedIn: 'root' })
export class AuthServerProvider {
  constructor(private http: HttpClient) { }

  getToken() {
    return localStorage.getItem('authenticationToken');
  }

  login(credentials: any): Observable<any> {
    const data = {
      email: credentials.email,
      password: credentials.password,
      rememberMe: credentials.rememberMe,
      general_data: credentials?.general_data
    };

    const authenticateSuccess = (resp: any) => {
      const jwt = resp.body.token;
      const user = resp.body.user;
      const person = resp.body.person;
      this.storeAuthenticationToken(jwt, credentials.rememberMe);
      return { jwt, user, person };
    }

    return this.http
      .post(SERVER_API_URL + 'auth/sign-in', data, { observe: 'response' })
      .pipe(map(authenticateSuccess.bind(this)));
  }

  loginFb({ token, email, general_data }: any): Observable<any> {
    const authenticateSuccess = (resp: any) => {
      const jwt = resp.body.token;
      const user = resp.body.user;
      const person = resp.body.person;
      const social_user = resp.body.social_user;
      this.storeAuthenticationToken(jwt, false);
      return { jwt, user, person, social_user };
    }

    return this.http
      .post(
        SERVER_API_URL + 'auth/sign-in/facebook',
        { access_token: token, email: email, general_data: general_data },
        { observe: 'response' }
      )
      .pipe(map(authenticateSuccess.bind(this)));
  }

  loginWithHash(hash: any): Observable<any> {
    return this.http
      .post(
        SERVER_API_URL + 'auth/hash-sign-in',
        { validationHash: hash },
        { observe: 'response' }
      )
      .pipe(map((resp: any) => {
        const jwt = resp.body.token;
        const user = resp.body.user;
        const person = resp.body.person;
        this.storeAuthenticationToken(jwt, false);
        return { jwt, user, person };
      }));
  }

  loginGoogle(token: any): Observable<any> {
    const authenticateSuccess = (resp: any) => {
      const jwt = resp.body.token;
      const user = resp.body.user;
      const person = resp.body.person;
      const social_user = resp.body.social_user;
      this.storeAuthenticationToken(jwt, false);
      return { jwt, user, person, social_user };
    }

    const payload =
      typeof token === 'string'
        ? { access_token: token }
        : {
          access_token: token.token,
          ...(token.general_data && { general_data: token.general_data })
        };

    return this.http
      .post(
        SERVER_API_URL + 'auth/sign-in/google',
        payload,
        { observe: 'response' }
      )
      .pipe(map(authenticateSuccess.bind(this)));
  }

  storeAuthenticationToken(jwt: any, rememberMe: any) {
    localStorage.setItem('authenticationToken', jwt);
  }

  logout(): Observable<any> {
    return new Observable((observer) => {
      localStorage.removeItem('authenticationToken');
      observer.complete();
    });
  }
}
